//@flow
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Row,
  Col,
  Button
} from 'reactstrap';
import { getCacheImage } from '../../config'

/*
type Props = {
  textTop: string,
  textCenter: string,
  img: string,
  onClick: Function,
  disabled: Boolean,
  buttonVerif: string,
  textBottom: string,
  textButton: string
}
*/

const CGContainer = (props) => (
    <div className="cg-container">
       <div className="CGForm">
        <div className="CG-title-wrapper">
          <p>{props.textTop}</p>
        </div>
        {
          props.textCenter ? 
          <div className="CG-title-wrapper">
            <p>{props.textCenter}</p>
          </div> : null
        }
        {
          props.img ?
          <div className="CG-image-wrapper">
            <KickImage src={getCacheImage(props.img)} alt={props.img} />
          </div> : null
        }
        {
          props.buttonVerif ?
          <Row className="btn-verif">
            <Col className="col-verif">
              <Button className="btn-green bold btn-send-verify"
                onClick={props.onClick}
                disabled={props.disabled}
                >
                {props.buttonVerif}
              </Button>
            </Col>
          </Row> : null
        }
        {
          props.textBottom ?
          <div className="CG-title-wrapper">
            <p>{props.textBottom}</p>
          </div> : null
        }
        {
          props.textButton ? <Button className="CG_btn" onClick={props.onClick}>{props.textButton}</Button> : null
        }
       </div>
    </div>   
  )

export default CGContainer;